import BACKEND_URL from '../config.js';

// Client HTTP della pagina pubblica di prenotazione. Non si usa lib/api.ts
// apposta: qui non c'è login, e apiFetch su 401 rimanderebbe al login di BOP.

export class ErrorePubblico extends Error {
  status: number;
  codice?: string;
  constructor(message: string, status: number, codice?: string) {
    super(message);
    this.status = status;
    this.codice = codice;
  }
}

const MESSAGGIO_SERVIZIO_NON_RAGGIUNGIBILE = 'Servizio momentaneamente non raggiungibile: riprova tra poco o chiama il negozio';

export async function pubblicoFetch<T>(path: string, options?: RequestInit): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`${BACKEND_URL}${path}`, {
      ...options,
      // Content-Type solo con un corpo: sulle GET renderebbe la richiesta "non semplice" e il browser farebbe una OPTIONS in più.
      headers: { ...(options?.body ? { 'Content-Type': 'application/json' } : {}), ...(options?.headers ?? {}) },
    });
  } catch {
    throw new ErrorePubblico('Connessione assente: controlla la rete e riprova', 0);
  }
  // null = corpo non JSON (pagina HTML di un proxy, risposta vuota…).
  const body = await res.json().catch(() => null) as { error?: string; codice?: string } | null;
  if (!res.ok) {
    const messaggio = body?.error
      ?? (res.status >= 500 ? MESSAGGIO_SERVIZIO_NON_RAGGIUNGIBILE : `Errore ${res.status}`);
    throw new ErrorePubblico(messaggio, res.status, body?.codice);
  }
  // Un 200 senza JSON non è una risposta utilizzabile: meglio un errore visibile che un "Caricamento…" infinito.
  if (body === null) throw new ErrorePubblico(MESSAGGIO_SERVIZIO_NON_RAGGIUNGIBILE, res.status);
  return body as T;
}

export const urlPubblica = (path: string): string => `${BACKEND_URL}${path}`;
